import { combineReducers } from 'redux'
import * as constants from './constants'
import { LOGOUT } from 'auth/constants'

const initialSelection = {
    enabled: false,
    selectedVehicleIds: [],
    selectedCardId: null,
}

const baseline = (state = initialSelection, action) => {
    switch (action.type) {
        case constants.SET_ON_DEMAND_PARKING_BASELINE:
            return {
                enabled: action.enabled ?? false,
                selectedVehicleIds: action.selectedVehicleIds || [],
                selectedCardId: action.selectedCardId ?? null,
            }
        case LOGOUT:
            return initialSelection
        default:
            return state
    }
}

const draft = (state = initialSelection, action) => {
    switch (action.type) {
        case constants.SET_ON_DEMAND_PARKING_BASELINE:
            return {
                enabled: action.enabled ?? false,
                selectedVehicleIds: action.selectedVehicleIds || [],
                selectedCardId: action.selectedCardId ?? null,
            }
        case constants.SET_ON_DEMAND_ENABLED:
            return {
                ...state,
                enabled: action.enabled,
            }
        case constants.TOGGLE_ON_DEMAND_VEHICLE: {
            const id = action.vehicleId
            const exists = state.selectedVehicleIds.includes(id)
            return {
                ...state,
                selectedVehicleIds: exists
                    ? state.selectedVehicleIds.filter(vId => vId !== id)
                    : [...state.selectedVehicleIds, id],
            }
        }
        case constants.SET_ON_DEMAND_CARD:
            return {
                ...state,
                selectedCardId: action.cardId,
            }
        case LOGOUT:
            return initialSelection
        default:
            return state
    }
}

export const onDemandParking = combineReducers({
    baseline,
    draft,
})
